import { useState, useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { enableWebPushNotifications } from "@/lib/webPush";
import { AppButton, AppButtonRow, AppCard, AppCardBody, AppText } from "../../ui-foundation";

const PushNotificationPrompt = () => {
  const { user } = useAuth();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!user || !("serviceWorker" in navigator) || !("PushManager" in window)) return;
    if (Notification.permission === "granted" || Notification.permission === "denied") return;

    const dismissed = localStorage.getItem("push_prompt_dismissed");
    if (dismissed && Date.now() - parseInt(dismissed) < 7 * 24 * 60 * 60 * 1000) return;

    const timer = setTimeout(() => setShow(true), 5000);
    return () => clearTimeout(timer);
  }, [user]);

  const handleEnable = async () => {
    setShow(false);
    try {
      await enableWebPushNotifications(user!.id);
    } catch (err) {
      console.error("Push subscription failed:", err);
    }
  };

  const handleDismiss = () => {
    setShow(false);
    localStorage.setItem("push_prompt_dismissed", Date.now().toString());
  };

  if (!show) return null;

  return (
    <AppCard>
      <AppCardBody>
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="min-w-0">
            <AppText fontSize="$sm" lineHeight="$sm" fontWeight="700">
              🔔 Stay in the loop
            </AppText>
            <AppText color="$colorMuted" fontSize="$sm" lineHeight="$md">
            Get notified when someone replies, joins your adventure, or messages you.
            </AppText>
          </div>
          <AppButtonRow>
            <AppButton type="button" size="sm" onPress={() => void handleEnable()}>
              Turn on notifications
            </AppButton>
            <AppButton type="button" tone="outline" size="sm" onPress={handleDismiss}>
              Maybe later
            </AppButton>
          </AppButtonRow>
        </div>
      </AppCardBody>
    </AppCard>
  );
};

export default PushNotificationPrompt;
